import { Box, Container, IconButton, Tooltip } from "@mui/material";
import { CloseIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { NewAnalysisForm } from "Components/Analyses/NewAnalysis/NewAnalysisForm";
import { NewAnalysisSelectedClient } from "Components/Analyses/NewAnalysis/NewAnalysisSelectedClient";
import { ClientsSearch } from "Components/_Shared/Client/ClientsSearch";
import { AuthenticatedLayout } from "Components/_Shared/Layouts/AuthenticatedLayout";
import type { SearchedClient, SearchedLocalClient } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const NewAnalysisPage: React.FunctionComponent = () => {
  const { t } = useResource();
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState<SearchedClient | SearchedLocalClient | null>(null);

  return (
    <AuthenticatedLayout
      title={t(Resources.NewAnalysis.Title)}
      container={false}
      header={{
        title: t(Resources.NewAnalysis.Title),
        actions: (
          <Tooltip title={t(Resources.Common.Close)}>
            <IconButton onClick={() => navigate(AppRouting.Analyses.path())} aria-label={t(Resources.Common.Close)}>
              <CloseIcon sx={{ color: "text.primary" }} />
            </IconButton>
          </Tooltip>
        ),
        children: <ClientsSearch includeLocalClients showAnalysisStatus onSelect={setSelectedClient} onSelectLocal={setSelectedClient} />,
        maxWidth: "sm",
        disableGutters: true,
      }}
    >
      <Container maxWidth="sm" disableGutters>
        <Box mt={Spacing.XXL}>
          {selectedClient ? (
            <NewAnalysisSelectedClient client={selectedClient} onCancel={() => setSelectedClient(null)} />
          ) : (
            <NewAnalysisForm onCancel={() => setSelectedClient(null)} onClientSelect={setSelectedClient} />
          )}
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
};
